(function () {
	'use strict';

	angular
		.module('wizard-future7.services')
		.service('LeadService', LeadService);

	function LeadService(HttpService) {
		const LeadService = {
			// Helpers
			postLead,
			// Savers
			saveAstronautName,
			saveAstronautParts,
			saveLeadData,
			saveLeadResult,
			// Getters
			getAstronautName,
			getAstronautParts,
			getLeadData,
			getLeadResult,
		};

		return LeadService;

		function postLead(leadData) {
			return HttpService.post('/lead', leadData);
		}

		function saveAstronautName(name) {
			localStorage.setItem('AstronautName', name);
		}

		function saveLeadData(leadData) {
			delete leadData.unitCity;
			delete leadData.unitName;
			delete leadData.unitState;
			localStorage.setItem('LeadData', JSON.stringify(leadData));
		}

		function saveAstronautParts(astronaut) {
			localStorage.setItem('AstronautParts', JSON.stringify(astronaut));
		}

		function saveLeadResult(resultData) {
			return HttpService.post('/lead/result', resultData);
		}

		function getAstronautName() {
			return localStorage.getItem('AstronautName');
		}

		function getLeadData() {
			return JSON.parse(localStorage.getItem('LeadData'));
		}

		function getAstronautParts() {
			return JSON.parse(localStorage.getItem('AstronautParts'));
		}

		function getLeadResult(hash) {
			return HttpService.get(`/lead/result/${hash}`);
		}

	}
})();